import ResponseManager from "helpers/responseManager";

/** Show error notification
 * @function
 * @param {object} showErrorConfig
 * @param {string} showErrorConfig.message - error message
 * @param {string} showErrorConfig.status - error status
 * @param {string} showErrorConfig.resource - error resource
 */

export const showError = ({ message, status, resource }) => {
	const err = {
		response: {
			data: { message, status, resource }
		}
	};
	ResponseManager.instance.processError(err);
};
